import { ExternalRequestsService } from './../services/external-requests.service';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ProfesionalesFormDialogComponent } from '../nosotros/nuestros-profesionales/profesionales-form-dialog/profesionales-form-dialog.component';

@Component({
  selector: 'app-dosimetria',
  templateUrl: './dosimetria.component.html',
  styleUrls: ['./dosimetria.component.scss']
})
export class DosimetriaComponent implements OnInit {

  dosimetriaForm: FormGroup;

  constructor(public dialog: MatDialog, private externalRequestsService: ExternalRequestsService) { 
    this.buildForm();
  }

  openDialog() {
    this.dialog.open(ProfesionalesFormDialogComponent);
  }
  
  ngOnInit(): void {
  }

  private buildForm() {
    this.dosimetriaForm = new FormGroup({
      company_name: new FormControl('', [Validators.required]),
      province: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      contact_name: new FormControl('', [Validators.required]),
      phone_number: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.email, Validators.required]),
    });
  }

  save(event: Event) {
    event.preventDefault();
    if (this.dosimetriaForm.valid) {
      const value = this.dosimetriaForm.value;
      value['request_type']="dosimetria";
      console.log(value);
      this.externalRequestsService.saveForm(value)
        .subscribe(
          res => {
            console.log(res);
          },
          err => console.log(err)
        )
      this.openDialog();
    } else {
      this.dosimetriaForm.markAllAsTouched();
    }
  }

}
